import AdventureQuest from './Games/AdventureQuest'
import SpaceInvader from './Games/SpaceInvader'
import PuzzleMaster from './Games/PuzzleMaster'
import SantaDrop from './Games/SantaDrop'
import Tetris from './Games/Tetris'
import { STACKFALL_DISPLAY_NAME } from './gameNames'
import Snake from './Games/Snake'
import TicTacToe from './Games/TicTacToe'
import Pong from './Games/Pong'
import ConnectFour from './Games/ConnectFour'
import TwoJointPole from './Games/TwoJointPole'
import OneArmedBandit from './Games/OneArmedBandit'
import Blackjack from './Games/Blackjack'
import LightsOut from './Games/LightsOut'
import Battleship from './Games/Battleship'
import Numberlink from './Games/Numberlink'
import Minesweeper from './Games/Minesweeper'
import RoadFighter from './Games/RoadFighter'
import PacMan from './Games/PacMan'
import { SI_DISPLAY_NAME } from './siBrand';

// Space Invader display name (one place; internal id stays space_invader).
export { SI_DISPLAY_NAME };

export { STACKFALL_DISPLAY_NAME };

export const gamesData = [
    {
        id: 'game1',
        backendId: 'adventure_quest',
        title: 'Adventure Quest',
        description: 'Embark on an epic adventure through a maze filled with challenges and treasures.',
        image: '/images/game1-preview.jpg',
        genre: 'Adventure',
        difficulty: 'Medium',
        component: AdventureQuest,
        color: '#FF6B35'
    },
    {
        id: 'game2',
        backendId: 'space_invader',
        title: SI_DISPLAY_NAME,
        description: 'Navigate through the cosmos, discover new worlds, and battle alien forces.',
        image: '/images/game2-preview.jpg',
        genre: 'Action',
        difficulty: 'Hard',
        component: SpaceInvader,
        color: '#4ECDC4'
    },
    {
        id: 'game3',
        backendId: 'sliding_tiles_puzzle',
        title: 'Sliding Tiles Puzzle',
        description: 'Test your wit and problem-solving skills with challenging brain teasers.',
        image: '/images/game3-preview.jpg',
        genre: 'Puzzle',
        difficulty: 'Easy',
        component: PuzzleMaster,
        color: '#45B7D1'
    },
    {
        id: 'game4',
        backendId: 'santa_drop',
        title: 'Santa Drop',
        description: 'Steer Santa\'s sled over the rooftops and drop gifts down the chimneys before the night runs out.',
        image: '/images/game4-preview.jpg',
        genre: 'Casual',
        difficulty: 'Easy',
        component: SantaDrop,
        color: '#E74C3C'
    },
    {
        id: 'game5',
        backendId: 'tetris',
        title: STACKFALL_DISPLAY_NAME,
        description: 'Stack falling blocks and clear lines in this falling-block puzzle.',
        image: '/images/tetris-preview.jpg',
        genre: 'Puzzle',
        difficulty: 'Medium',
        component: Tetris,
        color: '#3FA796'
    },
    {
        id: 'game6',
        backendId: 'snake2d',
        title: 'Snake',
        description: 'Control a growing snake and eat food without hitting walls or yourself.',
        image: '/images/snake-preview.jpg',
        genre: 'Arcade',
        difficulty: 'Easy',
        component: Snake,
        color: '#27AE60'
    },
    {
        id: 'game7',
        backendId: 'tic_tac_toe',
        title: 'Tic-Tac-Toe',
        description: 'Classic 3x3 Tic-Tac-Toe game.',
        image: '/images/tictactoe-preview.jpg',
        genre: 'Strategy',
        difficulty: 'Easy',
        component: TicTacToe,
        color: '#4ECDC4'
    },
    {
        id: 'game8',
        backendId: 'pong',
        title: 'Pong',
        description: 'Fast-paced battle of the paddles.',
        image: '/images/pong-preview.jpg',
        genre: 'Arcade',
        difficulty: 'Medium',
        component: Pong,
        color: '#FF6B35'
    },
    {
        id: 'game9',
        backendId: 'connect_four',
        title: 'Connect Four',
        description: 'Drop tokens — four in a row wins.',
        image: '/images/connect-four-preview.jpg',
        genre: 'Strategy',
        difficulty: 'Medium',
        component: ConnectFour,
        color: '#fbbf24'
    },
    {
        id: 'game10',
        backendId: 'two_joint_pole',
        title: 'Two-Joint Pole',
        description: 'Balance a double pendulum on a moving cart.',
        image: '/images/two-joint-pole-preview.jpg',
        genre: 'Simulation',
        difficulty: 'Hard',
        component: TwoJointPole,
        color: '#8E8CD8'
    },
    {
        id: 'game11',
        backendId: 'one_armed_bandit',
        title: 'One-Armed Bandit',
        description: 'Pull the lever, chase jackpots, and tune strategies against our slot machine simulator.',
        image: '/images/one-armed-bandit-preview.jpg',
        genre: 'Casino',
        difficulty: 'Medium',
        component: OneArmedBandit,
        color: '#F9A602'
    },
    {
        id: 'game12',
        backendId: 'blackjack',
        title: 'Blackjack Table',
        description: 'Face the dealer with hits, stands, and doubles while optimizing betting logic.',
        image: '/images/blackjack-preview.jpg',
        genre: 'Card Game',
        difficulty: 'Medium',
        component: Blackjack,
        color: '#1ABC9C'
    },
    {
        id: 'game13',
        backendId: 'lights_out',
        title: 'Lights Out Laboratory',
        description: 'Toggle tiles across a glowing grid to extinguish every light and speed-run solutions.',
        image: '/images/lights-out-preview.jpg',
        genre: 'Puzzle',
        difficulty: 'Hard',
        component: LightsOut,
        color: '#fbbf24'
    },
    {
        id: 'game14',
        backendId: 'battleship',
        title: 'Battleship',
        description: 'Triangulate hidden vessels, track hits, and master naval search strategies.',
        image: '/images/battleship-preview.jpg',
        genre: 'Strategy',
        difficulty: 'Medium',
        component: Battleship,
        color: '#4FC3F7'
    },
    {
        id: 'game15',
        backendId: 'numberlink',
        title: 'Numberlink',
        description: 'Connect matching numbers without crossing paths.',
        image: '/images/numberlink-preview.jpg',
        genre: 'Puzzle',
        difficulty: 'Medium',
        component: Numberlink,
        color: '#FF7043'
    },
    {
        id: 'game16',
        backendId: 'minesweeper',
        title: 'Minesweeper',
        description: 'Clear the minesfield without triggering any mines.',
        image: '/images/minesweeper-preview.jpg',
        genre: 'Puzzle',
        difficulty: 'Hard',
        component: Minesweeper,
        color: '#4FC3F7'
    },
    {
        id: 'game17',
        backendId: 'road_fighter',
        title: 'Road Fighter',
        description: 'Five escalating stages — dodge traffic, grab fuel packs, and sprint to each finish.',
        image: '/images/road-fighter-preview.jpg',
        genre: 'Racing',
        difficulty: 'Hard',
        component: RoadFighter,
        color: '#FF6B6B'
    },
    {
        id: 'game18',
        backendId: 'pac_man',
        title: 'Pac-Man',
        description: 'Navigate dark corridors, outsmart ghosts, and chomp every last pellet.',
        image: '/images/pac-man-preview.jpg',
        genre: 'Arcade',
        difficulty: 'Medium',
        component: PacMan,
        color: '#fbbf24'
    }
];